export default "__VITE_ASSET__BXB9_zpD__"